import type { UIStringsOverride } from "../i18n-ui.ts";

/** Spanish (es) UI strings. */
export const es: UIStringsOverride = {
  actions: {
    addToCursor: "Añadir a Cursor",
    addToVscode: "Añadir a VS Code",
    askAI: "Preguntar a la IA sobre esta página",
    connectMcp: "Conectar a MCP",
    copied: "¡Copiado!",
    copyClaudeCode: "Copiar comando de Claude Code",
    copyCode: "Copiar código",
    copyCodex: "Copiar comando de Codex",
    copyMarkdown: "Copiar como Markdown",
    copyServerUrl: "Copiar URL del servidor",
    edit: "Editar en GitHub",
    export: "Exportar",
    exportEpub: "Exportar a EPUB",
    exportPdf: "Exportar a PDF",
    generating: "Generando…",
    openIn: "Abrir en {name}",
    openInChat: "Abrir en el chat",
    scrollToTop: "Volver arriba",
  },
  ask: {
    ai: "IA",
    clear: "Borrar la conversación",
    close: "Cerrar",
    copy: "Copiar la conversación",
    empty: "Haz una pregunta sobre la documentación.",
    error: "Lo sentimos, algo salió mal.",
    label: "Haz una pregunta",
    placeholder: "Haz una pregunta…",
    send: "Enviar",
    tip: "Consejo: puedes abrir y cerrar el chat con",
    title: "Preguntar a la IA",
    you: "Tú",
  },
  banner: { dismiss: "Cerrar el anuncio" },
  changelog: {
    description: "Novedades del producto y notas de la versión.",
    showReleases: "Mostrar versiones {version}",
    title: "Registro de cambios",
  },
  content: {
    diagramError: "No se pudo mostrar este diagrama.",
  },
  feedback: {
    no: "No",
    question: "¿Te ha resultado útil esta página?",
    thanks: "¡Gracias por tus comentarios!",
    yes: "Sí",
  },
  languageSwitcher: { label: "Idioma", untranslated: "Sin traducir" },
  nav: {
    back: "Atrás",
    breadcrumb: "Ruta de navegación",
    closeNavigation: "Cerrar la navegación",
    deprecated: "obsoleto",
    featured: "Destacado",
    githubRepository: "Repositorio de GitHub",
    navigation: "Navegación",
    primary: "Principal",
    sections: "Secciones",
    toggleNavigation: "Mostrar u ocultar la navegación",
    toggleTheme: "Cambiar el tema de color",
  },
  notFound: {
    description: "No hemos podido encontrar la página que buscas.",
    home: "Volver al inicio",
    title: "Página no encontrada",
  },
  page: {
    lastUpdated: "Última actualización el",
    next: "Siguiente",
    pagination: "Paginación",
    previous: "Anterior",
    skipToContent: "Saltar al contenido",
  },
  search: {
    all: "Todos",
    allLanguages: "Todos los idiomas",
    askAi: "Preguntar a la IA",
    askAiHint: "Obtén una respuesta instantánea de la IA",
    button: "Buscar",
    devOnly: "La búsqueda está disponible en la compilación de producción.",
    error: "Algo salió mal. Inténtalo de nuevo.",
    label: "Buscar en la documentación",
    navigate: "navegar",
    noResults: "No se encontraron resultados.",
    open: "abrir",
    placeholder: "Buscar en la documentación…",
    popular: "Populares",
    preview: "vista previa",
    results: "Resultados",
  },
  toc: { title: "En esta página" },
};
